import React from 'react';

interface PropTypes {
  children: React.ReactNode;
  className?: string;
}

function LoadingContainer({ children, className }: PropTypes) {
  return (
    <div
      className={`flex flex-col justify-center items-center w-full h-full min-h-[100vh] ${className}`}
    >
      {children}
    </div>
  );
}

export default LoadingContainer;
